import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('locais-aplicacao',{
            headers:{
                'Authorization':token
            }
        })
    },
    listar1:async(token)=>{
        return await http.get('locais-aplicacao',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('locais-aplicacao',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('locais-aplicacao/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('locais-aplicacao/'+item.id_local_aplicacao,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}